export const ButtonComponentActionEmpty = () => {
  return <div className="w-7 h-5"></div>;
};
